import ServerAPI from '@/apis/server';
import CouponBook from '@/apis/books/coupon.json';

const getCoupon = (payload) => {
  const { description } = payload;
  return ServerAPI.get(`${CouponBook.REST}`, { params: { description } });
};

export { getCoupon };
